import { CurrencyTextField } from '@/common/components/CurrencyTextField'
import MaskedTextField from '@/common/components/MaskedTextField'
import { percentageMask } from '@/common/constants/masks.constant'
import { formatCurrency, formatPercentage } from '@/common/utils/formatters'
import { SpecialEntriesData } from '@/features/companies/types/companies.type'

interface ShowEntryTextFieldProps {
  specialEntry: SpecialEntriesData
  className?: string
}

export const ShowEntryTextField = ({ specialEntry, className }: ShowEntryTextFieldProps) => {
  return (
    <>
      {specialEntry.fee_template.calculate_as === 'percentage' ? (
        <MaskedTextField
          mask={percentageMask}
          label="Valor"
          value={specialEntry.value ? formatPercentage(Number(specialEntry.value)) : ''}
          className={className}
          disabled
        />
      ) : (
        <CurrencyTextField
          label="Valor"
          className={className}
          allowZero
          defaultValue={specialEntry.value ? formatCurrency(Number(specialEntry.value)) : ''}
          disabled
        />
      )}
    </>
  )
}
